import './DualRangeSlider.css';

/**
 * One track, two thumbs (overlapping native range inputs).
 */
export default function DualRangeSlider({
  min,
  max,
  low,
  high,
  step = 1,
  onChange,
  ariaLabel = 'Range'
}) {
  const lo = Math.min(low, high);
  const hi = Math.max(low, high);
  const span = Math.max(max - min, 1);
  const leftPct = ((lo - min) / span) * 100;
  const widthPct = ((hi - lo) / span) * 100;

  const setLow = (v) => {
    const n = Number(v);
    const nl = Math.min(Math.max(n, min), max);
    onChange({ low: nl, high: Math.max(nl, hi) });
  };

  const setHigh = (v) => {
    const n = Number(v);
    const nh = Math.min(Math.max(n, min), max);
    onChange({ low: Math.min(lo, nh), high: nh });
  };

  const zLow = lo >= hi - (span * 0.02 || 1) ? 4 : 2;
  const zHigh = hi <= lo + (span * 0.02 || 1) ? 4 : 3;

  return (
    <div className="dual-range-slider" role="group" aria-label={ariaLabel}>
      <div className="dual-range-slider__rail" aria-hidden />
      <div
        className="dual-range-slider__fill"
        style={{ left: `${leftPct}%`, width: `${widthPct}%` }}
        aria-hidden
      />
      <input
        type="range"
        className="dual-range-slider__input dual-range-slider__input--low"
        style={{ zIndex: zLow }}
        min={min}
        max={max}
        step={step}
        value={lo}
        onChange={(e) => setLow(e.target.value)}
        onInput={(e) => setLow(e.target.value)}
        aria-label={`${ariaLabel} minimum`}
      />
      <input
        type="range"
        className="dual-range-slider__input dual-range-slider__input--high"
        style={{ zIndex: zHigh }}
        min={min}
        max={max}
        step={step}
        value={hi}
        onChange={(e) => setHigh(e.target.value)}
        onInput={(e) => setHigh(e.target.value)}
        aria-label={`${ariaLabel} maximum`}
      />
    </div>
  );
}
